export interface EditableXmlField {
	id: string;
	tagName: string;
	label: string;
	path: string;
	value: string;
	isDateReference: boolean;
}

export interface ParsedXmlParameters {
	fields: EditableXmlField[];
}

function getElementChildren(element: Element): Element[] {
	return Array.from(element.children);
}

function parseXml(xml: string): XMLDocument {
	const xmlDocument = new DOMParser().parseFromString(xml, "text/xml");
	const parserError = xmlDocument.querySelector("parsererror");

	if (parserError || xmlDocument.documentElement.tagName !== "PARAMETRO") {
		throw new Error("A configuração deve conter um XML válido com raiz PARAMETRO.");
	}

	return xmlDocument;
}

function getLabelSegment(element: Element): string {
	const parent = element.parentElement;
	if (!parent) return element.tagName;

	const siblingsWithSameName = getElementChildren(parent).filter(
		(sibling) => sibling.tagName === element.tagName
	);

	if (siblingsWithSameName.length === 1) return element.tagName;

	return `${element.tagName}[${siblingsWithSameName.indexOf(element) + 1}]`;
}

export function parseXmlParameters(xml: string): ParsedXmlParameters {
	const xmlDocument = parseXml(xml);
	const root = xmlDocument.documentElement;
	const fields: EditableXmlField[] = [];

	const visit = (element: Element, nodePath: number[], labels: string[]) => {
		const children = getElementChildren(element);
		const currentLabels = [...labels, getLabelSegment(element)];

		if (children.length === 0) {
			fields.push({
				id: `xml-field-${nodePath.length > 0 ? nodePath.join("-") : "root"}`,
				tagName: element.tagName,
				label: currentLabels.join(" / "),
				path: currentLabels.join("/"),
				value: element.textContent || "",
				isDateReference:
					element.getAttribute("isDateReference") === "true",
			});
			return;
		}

		children.forEach((child, index) =>
			visit(child, [...nodePath, index], currentLabels)
		);
	};

	visit(root, [], []);

	return { fields };
}
